<template>
  <div style="display:inline-block;margin:0 10px">
    <el-button size="small" type="success" @click="showDialog">创建原料采购单</el-button>
    <el-dialog title="创建原料采购单" :visible.sync="dialogVisible" width="1150px">
      <el-form :inline="true" ref="addForm" :model="addForm">
        <el-form-item label="采购日期" prop="buy_date" label-width="100px">
          <el-date-picker
            size="small"
            v-model="addForm.buy_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="厂商名称" prop="supplier" :rules="{ required:true,message:'供应商不能为空',trigger:'change'}">
          <el-select
            placeholder="供应商"
            v-model="addForm.supplier"
            size="small"
            clearable
            filterable
          >
            <el-option
              v-for="(item,index) in $store.state.supplierList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-table :data="addForm.materialList" style="width:1050px;margin-left:30px" :border="true">
          <el-table-column align="center" prop="material_name" label="材质"></el-table-column>
          <el-table-column align="center" prop="material_size" label="规格">
            <template slot-scope="scope">
              <span v-for="(sizeNumber,idx) in scope.row.material_size.split('*')" :key="idx">
                <span v-if="sizeNumber!==''">
                  <span
                    v-if="sizeNumber.indexOf('/')===-1"
                    style="display:inline-block"
                  >{{sizeNumber.replace('@','↧').replace('^','φ')}}</span>
                  <span style="display:inline-block" v-else>
                    <span
                      style="display:inline-block;text-align:right"
                    >{{sizeNumber.split(/[+|-]/)[0].replace('@','↧').replace('^','φ')}}</span>
                    <span style="position:relative;width:32px;display:inline-block">
                      <sup
                        style="position:absolute;left:0px;bottom:5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                      >{{sizeNumber.match(/[+|-]/)[0]+sizeNumber.split(/[+|-]/)[1].split('/')[0]}}</sup>
                      <sub
                        style="position:absolute;left:2px;top:-5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                      >{{sizeNumber.match(/\/(.)/)[1]+sizeNumber.split(/[+|-]/)[2]}}</sub>
                    </span>
                  </span>
                  <span v-if="idx+1 !== scope.row.material_size.split('*').length">*</span>
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="重量">
            <template slot-scope="scope">
              <el-form-item
                :prop="`materialList.${scope.$index}.buy_count`"
                :rules="[{ pattern: /^\d*$/, message: '请输入数字', trigger: 'blur' },{ required:true,message:'数量不能为空',trigger:'blur'}]"
              >
                <el-input size="small" v-model="addForm.materialList[scope.$index].buy_count"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="单价">
            <template slot-scope="scope">
              <el-form-item
                :prop="`materialList.${scope.$index}.buy_price`"
                :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
              >
                <el-input size="small" v-model="addForm.materialList[scope.$index].buy_price"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="备注">
            <template slot-scope="scope">
              <el-form-item :prop="`materialList.${scope.$index}.remark`">
                <el-input size="small" v-model="addForm.materialList[scope.$index].remark"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="产品交付日期" width="215px">
            <template slot="header" slot-scope="scope">
              <div>产品交付日期</div>
              <el-date-picker
                size="small"
                v-model="quickDeliveredDate"
                type="date"
                placeholder="统一设置"
                style="width:150px"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <span style="display:hidden">{{scope.row}}</span>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="`materialList.${scope.$index}.deliver_date`"
                :rules="{ pattern: /^[^p]/, message: '请输入正确的日期', trigger: 'blur' }"
              >
                <el-date-picker
                  size="small"
                  v-model="addForm.materialList[scope.$index].deliver_date"
                  type="date"
                  placeholder="选择日期"
                  style="width:150px"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible=false">取消</el-button>
        <el-button size="small" :disabled="buttonDisable" type="primary" @click="addBuyOrder">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addBuyOrder } from '../api/index'
export default {
  props: ['selectList'],
  data () {
    return {
      dialogVisible: false,
      buttonDisable: false,
      quickDeliveredDate: '',
      addForm: {
        supplier: '',
        buy_date: new Date().format('yyyy-MM-dd'),
        materialList: []
      }
    }
  },
  watch: {
    selectList: {
      handler (selectList) {
        this.addForm.materialList = selectList.map(item => {
          return {
            material_name: item.material_name,
            material_size: item.material_size,
            product_id: item.product_id,
            buy_count: '',
            buy_price: '',
            deliver_date: '',
            remark: item.remark
          }
        })
      }
    },
    quickDeliveredDate (date) {
      this.addForm.materialList.forEach(item => {
        item.deliver_date = date
      })
    }
  },
  methods: {
    showDialog () {
      if (this.selectList.length === 0) {
        this.$message.error('请至少选择一个产品')
        return
      }
      this.addForm.supplier = this.selectList[0].supplier
      let isSame = true
      this.selectList.forEach(item => {
        item.supplier !== this.addForm.supplier && (isSame = false)
      })
      if (isSame) {
        this.dialogVisible = true
      } else {
        this.$message.error('请选择相同供货商的原料创建采购单')
      }
    },
    addBuyOrder () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.buttonDisable = true
          addBuyOrder(this.addForm).then(res => {
            this.dialogVisible = false
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.dialogVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
